import { AddTOTPForm } from '#components/patterns/totp/add/AddTOTPForm.tsx';
import { page, Titled } from '#util/title.ts';
import { RegisterMFALayout } from '../RegisterMFALayout.tsx';
import { useMFAEnrollmentRedirect } from '../useMFAEnrollmentRedirect.ts';

/**
 * First-time TOTP enrollment step. Reached from the {@link RegisterMFA} choice
 * screen, or directly when the browser can't offer a passkey.
 */
export function AddTOTPPage() {
  const onEnrolled = useMFAEnrollmentRedirect();

  return (
    <Titled title={() => page('Register MFA')}>
      <RegisterMFALayout>
        <h1 className="h2 mb-16">Protect your account</h1>
        <AddTOTPForm onSuccess={onEnrolled} />
        <p className="p-md">Pro tip: add a backup authenticator in account settings</p>
      </RegisterMFALayout>
    </Titled>
  );
}
